import { Event } from '.';

export default class EventDispatcher {
  private listeners: Array<Object>;

  private enterFrameFunc: Function;

  private enterFrameTimer: number;

  private intervalTimer: number;

  public useDeltaTime: boolean;

  private isEnterFrame: boolean;

  constructor() {
    this.listeners = [];
    this.useDeltaTime = false;
  }

  /*
   * リスナーを登録する
   */
  public addEventListener(
    type: string,
    func: Function,
    scope: any = null,
  ): void {
    if (!this.listeners) {
      this.listeners = [];
    }

    this.listeners.push({ type, func, scope });
  }

  /*
   * リスナーを削除する
   */
  public removeEventListener(type: string, func: Function): void {
    const ls: Array<Object> = this.listeners;
    const tmp: Array<Object> = [];

    for (let i: number = 0; i < ls.length; i += 1) {
      const ob: any = ls[i];

      if (ob.type !== type || ob.func !== func) {
        tmp.push(ob);
      }
    }

    this.listeners = tmp;
  }

  /*
   * 全ての登録リスナーを削除する
   */
  public removeAllEventListener(): void {
    this.listeners = [];
  }

  /*
   * リスナーを発行する
   */
  public dispatchEvent(evt: Event) {
    const ls: Array<Object> = this.listeners;
    if (!ls) return;

    for (let i: number = 0; i < ls.length; i += 1) {
      const ob: any = ls[i];

      if (ob.type === evt.type) {
        evt.target = this;
        // evt.setTarget(this);

        if (ob.scope) {
          ob.func.call(ob.scope, evt);
        } else {
          ob.func(evt);
        }

        // break;
      }
    }
  }

  /*
   * EnterFrame実行
   */
  public set onEnterFrame(func: Function) {
    if (this.enterFrameFunc) {
      this.deleteEnterFrame();
    }

    this.enterFrameFunc = func;
    const scope: EventDispatcher = this;

    if (this.useDeltaTime) {
      // デルタタイムあり
      if (!this.isEnterFrame) {
        this.isEnterFrame = true;
        let current: number = new Date().getTime();

        const loop = () => {
          if (!scope.enterFrameFunc) {
            scope.isEnterFrame = false;
            return;
          }

          const tmp: number = new Date().getTime();
          let deltaTime = tmp - current;
          if (deltaTime < 0) {
            deltaTime = 1;
          }
          scope.enterFrameFunc(deltaTime);
          current = tmp;
          scope.intervalTimer = requestAnimationFrame(() => loop());
        };

        loop();
      }
    } else if (!this.isEnterFrame) {
      // デルタタイムなし

      this.isEnterFrame = true;

      const loop = () => {
        if (!scope.enterFrameFunc) {
          scope.isEnterFrame = false;
          return;
        }
        scope.enterFrameFunc();
        scope.intervalTimer = requestAnimationFrame(() => loop());
      };
      loop();
    }
  }

  /*
   * EnterFrame停止
   */
  public deleteEnterFrame(): boolean {
    this.isEnterFrame = false;
    this.enterFrameFunc = null;
    cancelAnimationFrame(this.intervalTimer);
    this.intervalTimer = null;
    return true;
  }
}
